module.exports = __webpack_public_path__ + "assets/b92.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b92.png
// module id = 685
// module chunks = 0